import React from 'react';
import { renderTableTransportsResume } from './renderTableTransportsResume';
import $ from 'jquery';
import FactoryActions from './FactoryActions/FactoryActions';
import CardTransportModal from './CardTransportModal';
import ApiClient from '../libs/apiClient';
import { SERVICE_RESPONSE } from '../libs/utils/Const';
const apiClient = ApiClient.getInstance();
const headersDataTableInit = [
    { title: "Operador", value: true },
    { title: "Transportes vinculados", value: true },
    { title: "Configuración", value: true }

];
const duplicatedFilter = [
    { value: 'OP', label: 'Operador', duplicatedOp: 'Transportes Vinculados', iconHead: 'fa fa-user', iconBody: 'fa fa-truck' },
    // { value: 'TR', label: 'Transporte', duplicatedOp: 'Operadores Vinculados', iconHead: 'fa fa-truck', iconBody: 'fa fa-user' }
]
class ResumeTransportModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filter: { duplicated: 'OP', status: 'A' },//Transporte
            headersDataTable: headersDataTableInit,
            detailsData: null,
            listFilter: [],
            drivers: []
        };
    }
    componentDidMount = async () => {
        await this.loadCatalogs();
        await this.searchData();
        this.changeHeaders();
        this.createDataTable();
    }
    loadCatalogs = async () => {
        const { enableSpinner, showAlert } = this.props
        const { filter } = this.state
        enableSpinner(true)
        const respCatalogs = await apiClient.transportCatalogs(filter)
        enableSpinner(false)
        if (respCatalogs.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                drivers: respCatalogs?.data?.drivers ?? []
            })
        } else {
            showAlert({ type: 'error', message: respCatalogs?.message ?? '' })
        }


    }
    searchData = async () => {
        const { enableSpinner, showAlert } = this.props
        const { filter } = this.state
        enableSpinner(true)
        const respTransport = await apiClient.resumeTransports(filter)
        enableSpinner(false)
        if (respTransport.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                listFilter: respTransport?.data ?? []
            })
        } else {
            showAlert({ type: 'error', message: respTransport?.message ?? '' })
        }
    }
    createDataTable = () => {
        this.table = $('#dataTableTrResume').DataTable({
            "dom": '<"toolbar">frtip',
            "pagingType": "full_numbers",
            "columnDefs": [{
                "targets": 0,
                "orderable": false
            }],
            responsive: true,
        });

        this.getTableInfoResult();
        this.changePaging();
    };
    changePaging = () => {
        let value = $('#changePaginateSelect').val();
        this.table.page.len(value).draw();
        this.getTableInfoResult();
    }
    changeHeaders = () => {
        const { headersDataTable, filter } = this.state
        const findFilter = duplicatedFilter.find(filt => filt.value === filter?.duplicated ?? 'OP')
        if (findFilter) {
            headersDataTable[0].title = findFilter?.label
            headersDataTable[1].title = findFilter?.duplicatedOp
            this.setState({
                headersDataTable
            })
        }

    }
    getTableInfoResult = () => {

        let info = this.table.page.info();

        let num = 0;
        try {
            if (info && info.recordsDisplay !== 0) {
                num = 1;
            }
        } catch (error) {
            console.log(error)
        }

        $('#tableInfo').text((info.start + num) + " - " + info.end + " de " + info.recordsTotal);
        $('.dataTables_empty').text("No hay resultados por mostrar");
    };

    first = () => {
        this.table.page('first').draw('page');
        this.getTableInfoResult();


    }
    previous = () => {
        this.table.page('previous').draw('page');
        this.getTableInfoResult();
    }
    next = () => {
        this.table.page('next').draw('page');
        this.getTableInfoResult();
    }

    last = () => {
        this.table.page('last').draw('page');
        this.getTableInfoResult();

    }
    SearchInTable = key => {
        let value = key.target.value;
        let tabla = $('#dataTableTrResume').DataTable();
        tabla.search(value);
        tabla.draw();
        this.getTableInfoResult();
    }
    onChangeFilter = (key, value) => {
        const { filter } = this.state
        filter[key] = value
        this.setState({
            filter
        })
        switch (key) {
            case 'duplicated':
                this.changeHeaders();
                break;

            default:
                break;
        }
    }
    openDetails = async (selection) => {
        const { enableSpinner, showAlert } = this.props
        const { filter } = this.state
        enableSpinner(true)
        const respDetails = await apiClient.detailsResume(selection)
        enableSpinner(false)
        if (respDetails.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                detailsData: respDetails?.data ?? {}
            })
            $('#CardTransportModal').modal('show');
        } else {
            showAlert({ type: 'error', message: respDetails?.message ?? '' })
        }
    }
    render() {
        const { shadow, hideModal } = this.props;
        const { filter, headersDataTable, detailsData, listFilter, drivers } = this.state;

        const checkbox = {
            openDetails: this.openDetails
        }
        return (
            <div
                className="modal fade"
                id="ResumeTransportModal"
                tabIndex="-1"
                role="dialog"
                aria-hidden="true"
                data-backdrop="static"
            >
                <CardTransportModal
                    idValidation='CardTransportModal'
                    detailsData={detailsData}
                    filter={filter}
                    duplicatedFilter={duplicatedFilter}
                />
                <div className="modal-dialog modal-xl modal-dialog-centered" role="document">
                    <div
                        className="modal-content"
                        style={shadow
                            ? { boxShadow: "rgb(1 1 1 / 30%) 1px 1px 10px" }
                            : { boxShadow: "none" }
                        }
                    >
                        <div className="modal-header">
                            <h5 className="modal-title">
                                Resumen Transportes
                            </h5>
                            {/* <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                            >
                                <span>&times;</span>
                            </button> */}
                        </div>

                        <div className="modal-body">
                            <div className="row">
                                <FactoryActions
                                    props={{ ...this.props, view: 'resumeTr' }}
                                    filter={filter}
                                    onChangeFilter={this.onChangeFilter}
                                    duplicatedFilter={duplicatedFilter}
                                    drivers={drivers}
                                    searchData={this.searchData}
                                />
                            </div>
                            <div className="form-group mb-2">
                                <input className='form-control btn-outline-secondary dropdown-toggle listSerie hide-pc mr-sm-2' style={{ display: 'inline-flex' }} placeholder="Buscar en tabla" autoComplete="off" id='searchDataTableTrRsmn'
                                    type='search' aria-controls='dataTableTrResume' onChange={this.SearchInTable} />
                            </div>
                            <div className="w-100 table-scroll" style={{ maxHeight: '300px', minHeight: '300px', overflowY: 'auto' }}>
                                {renderTableTransportsResume(headersDataTable, listFilter, checkbox)}
                            </div>
                            <div className="d-flex flex-wrap justify-content-end align-items-center">
                                <div className="form-group mb-2">
                                    <label htmlFor="colFormLabelSm" className="col col-form-label col-form-label-sm text-right registros" style={{ width: 195 }}>
                                        Registros por página:
                                    </label>
                                </div>
                                <div className="form-group mb-2">
                                    <select
                                        className="col col-form-label col-form-label-sm text-right"
                                        style={{ width: 80 }}
                                        id='changePaginateSelect'
                                        onChange={this.changePaging}>
                                        <option value='5'>5</option>
                                    </select>&nbsp;&nbsp;
                                </div>

                                <div className="form-group mb-2">
                                    <label htmlFor="colFormLabelSm" id="tableInfo"
                                        className="col-form-label col-form-label-sm">
                                    </label>
                                </div>

                                <div className="d-flex align-items-center mb-2 flex-nowrap">
                                <button className="btn btn-link btn-sm " style={{ color: "black" }} data-toggle="tooltip"
                                    data-placement="top"
                                    title="Primera" onClick={this.first}><i
                                        className="fas fa-chevron-left btn-first"></i></button>
                                <button className="btn btn-link btn-sm" style={{ color: "black" }} data-toggle="tooltip"
                                    data-placement="top"
                                    title="Anterior" onClick={this.previous}><i
                                        className="fas fa-chevron-left"></i></button>

                                <button className="btn btn-link btn-sm" style={{ color: "black" }} data-toggle="tooltip"
                                    data-placement="top"
                                    title="Siguiente" onClick={this.next}><i
                                        className="fas fa-chevron-right"></i></button>
                                <button className="btn btn-link btn-sm" style={{ color: "black" }} data-toggle="tooltip"
                                    data-placement="top"
                                    title="Última" onClick={this.last}><i
                                        className="fas fa-chevron-right btn-last"></i></button>
                                </div>

                            </div>
                        </div>

                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-danger"
                                data-dismiss="modal"
                                onClick={hideModal}
                            >
                                Cerrar
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

export default ResumeTransportModal;
